var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReinstatement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#reinstatement_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.82 7.04c.707.444.92 1.378.475 2.086L60.011 19.14a1.51 1.51 0 01-2.084.476 1.514 1.514 0 01-.476-2.086l6.285-10.014a1.51 1.51 0 012.084-.476z",
    fill: "#ED1B2E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.539 17.056c.705.446.916 1.38.47 2.087-.861 1.364-2.035 3.1-3.786 4.111a1.51 1.51 0 01-2.065-.555 1.514 1.514 0 01.555-2.067c1.035-.597 1.867-1.722 2.74-3.106a1.51 1.51 0 012.086-.47z",
    fill: "#ED1B2E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.776 21.185a1.514 1.514 0 01-.55 2.067l-9.413 5.46a1.51 1.51 0 01-2.066-.551 1.514 1.514 0 01.55-2.068l9.413-5.46a1.51 1.51 0 012.066.552z",
    fill: "#ED1B2E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.377 22.494a1.513 1.513 0 011.362 1.649c-.101 1.076-.066 1.815.039 2.292.072.333.159.454.187.485.038.012.168.035.457-.025.435-.09 1.055-.336 1.887-.808a1.51 1.51 0 012.06.569c.412.727.158 1.65-.568 2.063-.96.545-1.892.958-2.765 1.14-.878.181-1.864.16-2.724-.403-.858-.56-1.288-1.461-1.487-2.374-.2-.91-.21-2-.095-3.224a1.512 1.512 0 011.647-1.364zm1.575 4.421l.006.003a.026.026 0 01-.006-.003zm.018.011a.022.022 0 01.005.004l-.005-.004z",
    fill: "#ED1B2E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.341 12.137a1.513 1.513 0 011.366 1.647l-.96 10.356a1.512 1.512 0 11-3.01-.28l.96-10.356a1.512 1.512 0 011.644-1.367z",
    fill: "#ED1B2E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.457 8.242c.706.446.919 1.38.474 2.087-.555.883-1.097 2.087-1.225 3.456a1.512 1.512 0 11-3.01-.282c.185-1.976.952-3.633 1.677-4.786a1.51 1.51 0 012.084-.475z",
    fill: "#ED1B2E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.626.245c.701.453.903 1.39.45 2.092l-5.161 8.007a1.51 1.51 0 01-2.09.45 1.514 1.514 0 01-.45-2.091L47.536.696a1.51 1.51 0 012.09-.451zM51.767 13.075c-.825-.51-1.83-.257-2.276.393a1.51 1.51 0 01-2.101.392 1.514 1.514 0 01-.392-2.103c1.416-2.067 4.245-2.556 6.349-1.262 2.186 1.324 2.994 4.162 1.609 6.368a1.51 1.51 0 01-2.084.475 1.514 1.514 0 01-.475-2.086c.419-.668.234-1.655-.617-2.17l-.013-.007z",
    fill: "#ED1B2E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.381 16.652c-.543-.33-1.147-.147-1.4.224a1.51 1.51 0 01-2.102.394 1.514 1.514 0 01-.393-2.103c1.224-1.791 3.648-2.207 5.465-1.1 1.871 1.135 2.588 3.59 1.383 5.503a1.51 1.51 0 01-2.085.471 1.514 1.514 0 01-.471-2.087c.23-.365.15-.97-.394-1.3l-.003-.002zM46.437 10.613c-.541-.333-1.164-.151-1.425.229a1.51 1.51 0 01-2.102.391 1.514 1.514 0 01-.39-2.104c1.23-1.796 3.676-2.213 5.495-1.097 1.873 1.137 2.622 3.597 1.391 5.534a1.51 1.51 0 01-2.086.465 1.514 1.514 0 01-.465-2.088c.234-.368.16-.98-.409-1.324l-.01-.006zM40.14 19.483a1.512 1.512 0 011.76-1.212 15.764 15.764 0 015.276 1.992l.005.003a15.215 15.215 0 013.781 3.256 1.514 1.514 0 01-.192 2.132 1.51 1.51 0 01-2.129-.193 12.19 12.19 0 00-3.027-2.607 12.742 12.742 0 00-4.263-1.607 1.513 1.513 0 01-1.212-1.764zM65.016 40.04c.834 0 1.511.677 1.511 1.512v32.093a1.512 1.512 0 11-3.023 0V41.552c0-.835.677-1.513 1.512-1.513z",
    fill: "#ED1B2E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.016 72.13c.834 0 1.511.678 1.511 1.514 0 3.519-2.938 6.353-6.438 6.353a1.512 1.512 0 010-3.026c1.888 0 3.415-1.536 3.415-3.327 0-.836.677-1.513 1.512-1.513z",
    fill: "#ED1B2E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.916 78.484c0-.836.676-1.513 1.511-1.513h53.662a1.512 1.512 0 010 3.026H6.427a1.512 1.512 0 01-1.511-1.513z",
    fill: "#ED1B2E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.514 72.13c.835 0 1.512.678 1.512 1.514 0 1.806 1.521 3.327 3.401 3.327a1.512 1.512 0 010 3.026c-3.495 0-6.424-2.821-6.424-6.353 0-.836.677-1.513 1.511-1.513z",
    fill: "#ED1B2E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.77.396a1.51 1.51 0 011.016-.393h37.303a1.512 1.512 0 010 3.026H23.37L3.026 21.545v52.1a1.512 1.512 0 11-3.023 0v-52.77c0-.426.18-.832.495-1.12L21.769.397z",
    fill: "#ED1B2E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.577 1.516c0-.836.677-1.513 1.512-1.513 3.517 0 6.438 2.837 6.438 6.353a1.512 1.512 0 11-3.023 0c0-1.793-1.515-3.327-3.415-3.327a1.512 1.512 0 01-1.512-1.513z",
    fill: "#ED1B2E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.016 4.843c.834 0 1.511.677 1.511 1.513v35.196a1.512 1.512 0 11-3.023 0V6.356c0-.836.677-1.513 1.512-1.513zM23.767.003c.835 0 1.511.677 1.511 1.513v17.85a1.512 1.512 0 11-3.023 0V1.517c0-.836.677-1.513 1.512-1.513z",
    fill: "#ED1B2E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.767 17.854c.835 0 1.511.677 1.511 1.513 0 2.285-1.897 4.104-4.141 4.104a1.512 1.512 0 010-3.027c.628 0 1.119-.516 1.119-1.077 0-.836.676-1.514 1.51-1.514z",
    fill: "#ED1B2E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.003 21.957c0-.835.677-1.513 1.511-1.513h19.63a1.512 1.512 0 010 3.027H1.514a1.512 1.512 0 01-1.511-1.514zM7.766 34.093c0-.836.677-1.513 1.512-1.513h38.967a1.512 1.512 0 010 3.026H9.278a1.512 1.512 0 01-1.512-1.513zM7.766 46.228c0-.836.677-1.513 1.512-1.513h32.924a1.512 1.512 0 010 3.026H9.278a1.512 1.512 0 01-1.512-1.513zM7.766 58.364c0-.836.677-1.513 1.512-1.513h38.967a1.512 1.512 0 010 3.026H9.278a1.512 1.512 0 01-1.512-1.513zM7.766 70.499c0-.836.677-1.514 1.512-1.514H58.73a1.512 1.512 0 010 3.027H9.278a1.512 1.512 0 01-1.512-1.513z",
    fill: "#ED1B2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.016 61.723c8.548 0 15.477-6.938 15.477-15.495 0-8.557-6.93-15.495-15.477-15.495-8.548 0-15.477 6.938-15.477 15.495 0 8.557 6.929 15.495 15.477 15.495z",
    fill: "#E5EAEF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.016 32.246c-7.713 0-13.966 6.26-13.966 13.982 0 7.721 6.253 13.981 13.966 13.981 7.713 0 13.965-6.26 13.965-13.981 0-7.722-6.252-13.982-13.965-13.982zM48.027 46.228c0-9.394 7.606-17.008 16.989-17.008 9.382 0 16.988 7.614 16.988 17.008 0 9.393-7.606 17.007-16.988 17.007-9.383 0-16.989-7.614-16.989-17.007z",
    fill: "#ED1B2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.951 37c-4.957 0-8.962 4.029-8.962 9H54l3.88 3.895.07.144L61.97 46h-2.987c0-3.865 3.123-7 6.974-7s6.975 3.135 6.975 7-3.124 7-6.975 7a6.94 6.94 0 01-4.928-2.055L59.62 52.36A8.897 8.897 0 0065.953 55c4.957 0 8.972-4.029 8.972-9s-4.016-9-8.974-9zm-.992 5v5.001l4.265 2.54.718-1.214-3.487-2.078V42h-1.496z",
    fill: "#ED1B2E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "reinstatement_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h82v80H0z"
  })))));
}

export default SvgReinstatement;